import React, { useState } from "react";
import "./WeatherApp.css";
import axios from "axios";
import WeatherInfo from "./WeatherInfo";
import WeatherForecast from "./WeatherForecast";

export default function WeatherApp(props) {
  const [weatherData, setWeatherData] = useState({ ready: false });
  const [city, setCity] = useState(props.city);
  function handleResponse(response) {
    setWeatherData({
      ready: true,
      coordinates: response.data.coord,
      temperature: response.data.main.temp,
      description: response.data.weather[0].main,
      humidity: response.data.main.humidity,
      wind: response.data.wind.speed,
      city: response.data.name,
      date: new Date(response.data.dt * 1000),
      icon: response.data.weather[0].icon,
    });
  }

  function search() {
    const apiKey = "6782253072f7d90462731a624097fc54";
    let apiUrl = `https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=${apiKey}&units=metric`;
    axios.get(apiUrl).then(handleResponse);
  }

  function handleSubmit(event) {
    event.preventDefault();
    search();
  }

  function handleCityChange(event) {
    setCity(event.target.value);
  }

  if (weatherData.ready) {
    return (
      <div className="currentWeather">
        <form onSubmit={handleSubmit}>
          <div className="container">
            <div className="row">
              <div className="col-8 ps-0">
                <input
                  type="search"
                  placeholder="Enter a city"
                  className="searchbar w-100"
                  autoFocus="on"
                  onChange={handleCityChange}
                ></input>
              </div>
              <div className="col-4">
                <input
                  type="submit"
                  value="Search"
                  className="searchButton w100"
                ></input>
              </div>
            </div>
          </div>
        </form>
        <WeatherInfo data={weatherData} />
        <WeatherForecast data={weatherData.coordinates} />
      </div>
    );
  } else {
    search();
    return "Loading...";
  }
}
